import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MFADeviceTypeEnum } from '@modules/api/mfa-device-type-enum.generated';
import { MFADevice } from '@modules/api/mfa-device.generated';

@Component({
    selector: 'app-login-user-contact-methods',
    templateUrl: './login-user-contact-methods.component.html',
    styleUrls: ['./login-user-contact-methods.component.scss']
})
export class LoginUserContactMethodsComponent {
    @Input()
    public devices!: MFADevice[];
    @Input()
    public formGroup!: FormGroup;

    public MFADeviceTypeEnum = MFADeviceTypeEnum;
}
